import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button'
import { getAppEnabled, getAppState } from '../../../../Resources/Organization/Apps/AppsData.js'
import Switch from 'housecall-ui/dist/DesignSystem/Inputs/Switches/Switch'
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography'
import ConfirmationDialog from 'housecall-ui/dist/DesignSystem/Feedback/Dialog/ConfirmationDialog'
import { toggleEnabledWithEntity, enableAppState } from '../Redux/Actions.js'
import { DISPATCH, STATE_ENABLED, STATE_PENDING } from '../AppsData.js'
import FormControlLabel from 'housecall-ui/dist/DesignSystem/Inputs/FormControls/FormControlLabel'

const DispatchButton = () => {
  const appEnabled = useSelector(getAppEnabled(DISPATCH))
  const appState = useSelector((state) => getAppState(state, DISPATCH))
  const [dialogOpen, setDialogOpen] = useState(false)
  const dispatch = useDispatch()


  const onToggleAppEnabled = () => dispatch(toggleEnabledWithEntity(DISPATCH))

  const onAcceptClick = () => {
    setDialogOpen(false)
    onToggleAppEnabled()
  }

  const renderContent = () => {
    if (appState === STATE_ENABLED) {
      return (
        <FormControlLabel
          control={<Switch checked={appEnabled} onChange={onToggleAppEnabled} />}
          label={appEnabled ? 'Active' : 'Disabled'}
        />
      )
    } else if (appState === STATE_PENDING) {
      return (
        <Button variant='contained' color='primary' disabled>
          Pending
        </Button>
      )
    } else {
      return (
        <Button variant='contained' color='primary' onClick={() => setDialogOpen(true)}>
          Enable
        </Button>
      )
    }
  }

  return (
    <>
      {renderContent()}
      <ConfirmationDialog
        open={dialogOpen}
        title='Authorize Dispatch'
        onClose={() => setDialogOpen(false)}
        leftButton={
          <Button onClick={() => setDialogOpen(false)}>
            Cancel
          </Button>
        }
        rightButton={
          <Button color='primary' onClick={onAcceptClick}>
            Accept
          </Button>
        }>
        <Typography variant='body1'>
          By accepting, you are agreeing to allow Dispatch to create jobs in your account on your behalf.
        </Typography>
      </ConfirmationDialog>
    </>
  )
}

export default DispatchButton
